import { make } from 'vuex-pathify';

const state = {
  tableHeight: 1,
  floatingFilterOpened: true,
};

const mutations = make.mutations(state);

export default {
  namespaced: true,
  state,
  mutations,
};
